import { useSelector } from 'react-redux';
import { LaunchedUnitsECOMAP } from './launchedUnits';

import './primaryCharts.scss';

export const PrimaryCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);

  return (
    <div className={`primary-charts ${isGridView ? '' : 'list-layout'}`}>
      <LaunchedUnitsECOMAP />
    </div>
  );
};
